import React, {Component} from 'react';

import classes from './section_header.css';

class SectionHeader extends Component {

    render () {
        return (
            <div className="flex items-center justify-between cursor-default font-light text-left text-gray-500 py-2 px-4 mt-5">
                <p className="text-xs font-semibold uppercase tracking-wider text-gray-400">{this.props.text}</p>
                <div className="text-sm">{this.props.accessory}</div>
            </div>
        );
    }
}

export default SectionHeader;
